module.exports = __webpack_public_path__ + "static/media/zaid_romero.61f2b92c.jpg";